import axios from 'axios'
import SessionHelper from '../shared/helpers/SessionHelper';
axios.interceptors.request.use(function(config) {
    const token = SessionHelper.getAccessToken();
    if(token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function(err) {
    return Promise.reject(err);
});
export default class ApiWrapper {

    constructor() {
        axios.defaults.baseURL = this.getBaseUrl();
    }

    get(url, config) {
        return axios.get(url, config)
    }

    post(url, data, config) {
        return axios.post(url, data, config)
    }

    put(url, data, config) {
        return axios.put(url, data, config)
    }

    delete(url, config) {
        return axios.delete(url, config)
    }

    all(requestsCollection) {
        return axios.all(requestsCollection)
    }

    getBaseUrl() {
        if (import.meta.env.DEV) {
            return '';
        }
        return location.protocol + '//' + location.hostname;
    }
}